import { Injectable, inject } from '@angular/core';

import { SportsCacheService } from '@frontend/sports/betting-offer/feature/sports-cache';
import { LiveUrlParam, UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';
import { WidgetPage } from '@frontend/sports/types/components/widget';
import { WidgetLayoutHook } from '@frontend/sports/widget/feature/layout';

import { LiveNowLinkRegisterService } from '../live-now-item/live-now-link-register.service';

@Injectable({ providedIn: 'root' })
export class ESportLiveButtonService extends WidgetLayoutHook {
    private liveButton = inject(LiveNowLinkRegisterService);
    private cache = inject(SportsCacheService);
    private urlHelper = inject(UrlHelperService);

    constructor() {
        super(WidgetPage.ESportsLobby);
    }

    onResolve(): void {
        this.cache.getSportList().subscribe((sports) => {
            this.liveButton.addLiveButtonWithMultipleSports(
                sports.filter((sport) => sport.isEsport),
                this.urlHelper.getLiveUrl(LiveUrlParam.Esports),
            );
        });
    }

    onDestroy(): void {
        this.liveButton.removeLiveButton();
    }
}
